import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { invokeApi } from "../../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function Addmoveform(props) {
  const classes = useStyles();
  const [name, setname] = useState();
  const [isactive, setisactive] = useState(false);
  const [errorflag, setflag] = useState("");
  const [iswaiting, setiswaiting] = useState(false);

  const handlesubmit = (event) => {
    event.preventDefault();
    setiswaiting(true);

    addservicearea();
  };
  const addservicearea = () => {
    let is_Active;
    if (isactive) {
      is_Active = "1";
    } else {
      is_Active = "0";
    }
    let Data = {
      name: name,
      is_active: is_Active,
    };
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/add_move_type",
      method: "POST",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        setiswaiting(false);
        props.history.push("/admin/move-size");
      } else {
        setiswaiting(false);
        setflag(res.message);
      }
    });
  };
  const handleback = () => {
    props.history.push({ pathname: props.history.location.state.route });
  };
  const handlename = (event) => {
    setname(event.target.value);
  };
  const handleisactivechanged = (event) => {
    if (isactive) {
      setisactive(false);
    } else if (!isactive) {
      setisactive(true);
    }
  };
  if (iswaiting) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="sm">
        <ArrowBackIcon
          className="backarrow"
          color="primary"
          onClick={handleback}
        ></ArrowBackIcon>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Add move size
          </Typography>
          {errorflag && (
            <Alert className={classes.alert} severity="error">
              {errorflag}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handlesubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="name"
                  onChange={handlename}
                  label="Name"
                  name="Name"
                  autoFocus
                />
              </Grid>
            </Grid>
            Status:
            <Switch
              checked={isactive}
              onChange={handleisactivechanged}
              color="primary"
              name="status"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Add Move
            </Button>
          </form>
        </div>
      </Container>
    </>
  );
}
export default withRouter(Addmoveform);
